import type { DomainEntitlements } from "@/types";

type Props = {
  entitlements: DomainEntitlements;
};

export default function AccountQuotaChip({ entitlements }: Props) {
  const domainLimitLabel = entitlements.domain_limit == null ? "∞" : String(entitlements.domain_limit);

  return (
    <div className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700">
      <span className="font-medium">
        {entitlements.audits_remaining}/{entitlements.audit_limit} page audits left
      </span>
      <span className="mx-2 text-gray-300">·</span>
      <span>
        {entitlements.domains_used}/{domainLimitLabel} domains
      </span>
    </div>
  );
}
